'use memo'

import React from 'react'
import colors from '@sportninja/common/constants/appColors'

type HeaderSaveIconProps = {
  color?: string
  size?: number
}

// Floppy-disk save glyph matching the Registration Setup header save icon.
const HeaderSaveIcon: React.FC<HeaderSaveIconProps> = ({
  color = colors.SECONDARY_300,
  size = 24,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      aria-hidden='true'
    >
      <path
        d='M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM19 19H5V5H16.17L19 7.83V19ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6H15V10H6V6Z'
        fill={color}
      />
    </svg>
  )
}

export default HeaderSaveIcon
